// caseService.ts / .js (con TS types si usas TS)
import axios, { AxiosHeaders, InternalAxiosRequestConfig } from "axios"

class CaseService {
  api

  constructor() {
    this.api = axios.create({
      baseURL: process.env.REACT_APP_API_URL || "http://localhost:8000/api/v1",
    })

    this.api.interceptors.request.use((config) => {
      // Asegura que headers sea una instancia de AxiosHeaders
      config.headers = AxiosHeaders.from(config.headers)
      const headers = config.headers

      const token = localStorage.getItem("Token")
      if (token) {
        headers.set("Authorization", `Token ${token}`)
      }

      headers.set("Content-Type", "application/json; charset=UTF-8")
      // Si necesitas Accept u otros:
      // headers.set("Accept", "application/json");

      // ¡OJO! withCredentials va en config, no en headers
      config.withCredentials = false

      return config
    })
  }

  async getCaseListPaginate(page = 1, limit = 10) {
    const { data } = await this.api.get("/cases/case-list/", {
      params: { page, default_limit: limit },
    })
    return data
  }
}

export default new CaseService()
